import { RawTag } from '@/models/api/tags'
import { MailMagazineService } from '@spa/services/mailMagazine'

import { Either } from 'fp-ts/lib/Either'
import _ from 'lodash'

/**
 * ユーザが各メールマガジンに対して購読状態ON/OFFを変更するためのインタラクタ。
 */
export class MailMagazineSubscriptionInteractor {
  static initWithDefaultRepository(): MailMagazineSubscriptionInteractor {
    return new MailMagazineSubscriptionInteractor(
      [],
      new MailMagazineService()
    )
  }

  /**
   * TODO: RawTagの露出を防ぐ。
   * またEngineからのreadonlyなリスポンスとしてのRawTagではなく、ユーザがUI上で表明した希望をRawTagで表現してしまっているため、RawTagとしても責務が曖昧になっている。
   * @param subscriptionList 各メールマガジンに対する購読状態。
   * @param mailMagazineService メールマガジンの購読状態などを永続化するサービス層。 TODO: 必要なI/Fのみに依存させる。
   */
  constructor(
    public readonly subscriptionList: RawTag[],
    private readonly mailMagazineService: MailMagazineService
  ) {}

  /**
   * 各メールマガジンに対する新しい購読状態を保持するインタラクタを生成する。
   */
  update(subscriptionList: RawTag[]): MailMagazineSubscriptionInteractor {
    return new MailMagazineSubscriptionInteractor(
      subscriptionList,
      this.mailMagazineService
    )
  }

  /**
   * 一定のブランドの範囲内のメールマガジンすべてに対して、購読を希望するという購読状態を伴ったインタラクタを返す。
   * ユーザが現に保持している購読状態に関わらず、購読を希望するという状態で生成されることに注意。
   */
  async updateWithSpecifiedBrandSubscriptionAsFollowed(
    brandList: string[]
  ): Promise<Either<Error, MailMagazineSubscriptionInteractor>> {
    return (await this.mailMagazineService.listAsUser({
      with: 'follow',
    })).map((tags) => {
      return new MailMagazineSubscriptionInteractor(
        tags
          .filter(tag => brandList.includes(tag.name))
          .map(tag => ({ ...tag, follow: true })),
        this.mailMagazineService
      )
    })
  }

  async persistSubscription(): Promise<Either<Error, void>> {
    const [
      subscribeMailMagazinePaths,
      unsubscribeMailMagazinePaths,
    ] = _.partition(this.subscriptionList, magazine => magazine.follow)
      .map(list => list.map(magazine => magazine.pathname))

    return this.mailMagazineService.changeSubscriptionStatus(
      subscribeMailMagazinePaths,
      unsubscribeMailMagazinePaths
    )
  }
}
